import { useContext } from "react";
import DropdownIcon from "../../DropdownIcon";
import { FormControl, ListSubheader, MenuItem, Select, Typography } from "@mui/material";
import { classes } from "../classes";

export default function Area({ context }) {
   
    const {
        area, setArea,
        areasList,
    } = useContext(context);

    return (
        <div id='map-container'>
            <Typography style={classes.labelInput}>
                Tipo de Ocorrência:
            </Typography>

            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={area}
                    onChange={(e) => { setArea(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>

                    {areasList.map((res, index) => {
                        let components = [];

                        if (index === 0 || areasList[index - 1].groupId !== res.groupId)
                            components.push(<ListSubheader>{res.group?.nameSecretary}</ListSubheader>);

                        components.push(<MenuItem value={res.name} key={res.name} sx={{ marginLeft: 2 }}>
                            {res.name}
                        </MenuItem>);

                        return components;
                    })}
                </Select>
            </FormControl>
        </div>
    )
}